function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  d: "M64,45.732318 L64,45.9216696 C63.9867143,52.1304591 63.3261981,54.4110256 62.0966795,56.7100256 C60.8547415,59.0322479 59.0322479,60.8547415 56.7100256,62.0966795 C54.4110256,63.3261981 52.1304591,63.9867143 45.9216696,64 L45.732318,64 L18.267682,64 L18.0783304,64 C11.8695409,63.9867143 9.58897436,63.3261981 7.28997436,62.0966795 C4.96775214,60.8547415 3.14525855,59.0322479 1.90332051,56.7100256 L1.83023282,56.5720762 C0.659707378,54.3412301 0.0260284787,52.0534599 0,46.1067587 L0,45.9216696 L0,18.0783304 C0.0132857051,11.8695409 0.67380186,9.58897436 1.90332051,7.28997436 C3.14525855,4.96775214 4.96775214,3.14525855 7.28997436,1.90332051 L7.42792382,1.83023282 C9.6587699,0.659707378 11.9465401,0.0260284787 17.8932413,0 L18.0783304,0 L45.9216696,0 C52.1304591,0.0132857051 54.4110256,0.67380186 56.7100256,1.90332051 C59.0322479,3.14525855 60.8547415,4.96775214 62.0966795,7.28997436 C63.3261981,9.58897436 63.9867143,11.8695409 64,18.0783304 L64,18.267682 L64,45.732318 Z",
  id: "path-1"
}), React.createElement("filter", {
  x: "-10.2%",
  y: "-8.6%",
  width: "120.3%",
  height: "120.3%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Main-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "About-_-Modal-View",
  transform: "translate(-151.000000, -1053.000000)"
}, React.createElement("g", {
  id: "View",
  transform: "translate(0.000000, 190.000000)"
}, React.createElement("g", {
  id: "Item",
  transform: "translate(24.000000, 866.000000)"
}, React.createElement("g", {
  id: "Icon",
  transform: "translate(131.000000, 0.000000)"
}, React.createElement("g", {
  id: "Path"
}, React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "ic_",
  transform: "translate(16.000000, 16.000000)"
}, React.createElement("g", {
  id: "Icon",
  transform: "translate(1.000000, 0.000000)",
  fill: "#FFAD2F"
}, React.createElement("path", {
  d: "M17,5.33333333 L13,5.33333333 L13,2 C13,0.894666667 13.8946667,0 15,0 C16.1053333,0 17,0.894666667 17,2 L17,5.33333333 Z",
  id: "Fill-1"
}), React.createElement("path", {
  d: "M15,32 C17.2093333,32 19,30.2093333 19,28 L11,28 C11,30.2093333 12.7906667,32 15,32",
  id: "Fill-6"
}), React.createElement("path", {
  d: "M15,3 C8.45868347,3 3.1569405,8.30174297 3.1569405,14.8430595 L3.1569405,21.2198891 L-0.785482419,27.2848515 C-1.35394927,28.159922 -0.726267121,29.31791 0.318553906,29.31791 L3.1569405,29.31791 L26.8430595,29.31791 L29.6814461,29.31791 C30.7262671,29.31791 31.3539493,28.159922 30.7854824,27.2848515 L26.8430595,21.2198891 L26.8430595,15.2483553 C26.8430595,8.94126818 22.0834655,3.43292962 15.7882214,3.02631791 C15.5237264,3.00789537 15.2605473,3 15,3 M15,6.9476865 C15.17633,6.9476865 15.3552918,6.95295008 15.5329377,6.96479314 C19.6609019,7.23191993 22.895373,10.870371 22.895373,15.2483553 L22.895373,21.2198891 L22.895373,22.3897202 L23.5335823,23.3713782 L24.8323712,25.3702235 L5.16762882,25.3702235 L6.46641768,23.3713782 L7.104627,22.3897202 L7.104627,21.2198891 L7.104627,14.8430595 C7.104627,10.4887613 10.6457018,6.9476865 15,6.9476865",
  id: "Fill-3"
})), React.createElement("g", {
  id: "Icon",
  transform: "translate(20.000000, 17.000000)"
}, React.createElement("rect", {
  id: "icon",
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 20,
  height: 20,
  rx: 10
}), React.createElement("rect", {
  id: "icon",
  fill: "#FFE72E",
  x: 2,
  y: 2,
  width: 16,
  height: 16,
  rx: 8
}), React.createElement("g", {
  id: "ic_loop",
  transform: "translate(4.144766, 6.644766)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M4.11046864,-1.07913678e-13 L5.855,2.18 L7.6,-1.07913678e-13 L8.46046864,-1.07913678e-13 C10.2553941,-1.07913678e-13 11.7104686,1.45507456 11.7104686,3.25 L11.7047588,3.43862608 C11.5929767,5.16693648 10.1759515,6.5 8.46046864,6.5 L7.6,6.5 L5.855,4.318 L4.11046864,6.5 L3.25,6.5 C1.53451713,6.5 0.117491893,5.16693648 0.00570983646,3.43862608 L0.00570983646,3.43862608 L2.14050999e-13,3.25 C2.14050999e-13,1.45507456 1.45507456,-1.07913678e-13 3.25,-1.07913678e-13 L3.25,-1.07913678e-13 L4.11046864,-1.07913678e-13 Z M3.391,1.5 L3.25,1.5 C2.33437002,1.5 1.58298078,2.20319819 1.50609011,3.07838393 L1.50609011,3.07838393 L1.49960784,3.22574961 L1.50374284,3.36579812 C1.56320795,4.28196562 2.32646703,5 3.25,5 L3.25,5 L3.39,5 L4.79,3.25 L3.391,1.5 Z M8.46046864,1.5 L8.31946864,1.5 L6.92046864,3.25 L8.32046864,5 L8.46046864,5 C9.3840016,5 10.1472607,4.28196562 10.2067258,3.36579812 L10.2108608,3.22574961 L10.2043785,3.07838393 C10.1274879,2.20319819 9.37609862,1.5 8.46046864,1.5 Z",
  id: "Path"
})))))))));

var SvgPic3 = function SvgPic3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPic3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pic_3.a792cfbe.svg";
export { ForwardRef as ReactComponent };